export const fromClonedDeal = deal => {
  return {
    name: deal.name,
    status: deal.status.value,
    dealManagerId: deal.dealManager.value,
    dueDate: deal.dueDate,
    followUpDate: deal.followUpDate,
    copyProposalTemplates: deal.copyProposalTemplates,
    linkDeals: deal.linkDeals,
    related: deal.related
  }
}
